import React, {useState, useEffect} from "react";
import {Button, Checkbox, Col, Layout, Row} from "antd";
import { ToastContainer, toast } from "react-toastify";
import {getCookie, redirectTo} from '../../config/CoreMethods'
import axiosData from "../../helpers/axiosData";
import {Link, NavLink} from "react-router-dom";
import { useSelector } from "react-redux";
import {basePath, PATH} from "../../config";
import {ROUTES as ROUTES_CONFIG} from "../../config/constants";
import { selectUser } from "../../redux/features/userSlice";

const { Content } = Layout

const Register = () => {

    const [UserData, setUserData] = useState({});
    const [FormTrigger, setFormTrigger] = useState(1);
    const [errors, setErrors] = useState([]); 
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [Referrer, setReferrer] = useState('');
    const [Agrement, setAgrement] = useState(false);
    const [Error, setError] = useState(false);

    const ChangeAgrement = (value) => { 
        setAgrement(value)
        console.log( 'value', value ); 
    } 

    const setFormUsername = (value) => {

        if ( /^([A-Za-z0-9_.]{4,30})$/.test(value) ) {
            setFormData(value, 'username');
            setError(false)
        } else {
            // toast.error('Please fill valid characters');
            setError(true)
        }
    }

    let GetUser = useSelector(state => state.user.user)
    if (GetUser && GetUser.id) {
        redirectTo('/profile')
    }

 
    // add form data to state
    const setFormData = (data, key, type='text') => {

        // console.log('setFormData - data, key, type', data, key, type, ' ----- UserData', UserData)

        let newUserData = UserData; 

        if (type === 'text' || type === 'check') { 

            if(type === 'check') {

                newUserData[key] =  data ? 1 : 0;
            } else {
                newUserData[key] = data;
            }

            setUserData(newUserData);
            setFormTrigger(FormTrigger+1);
        }
        
        // console.log('FormData ', UserData)
    }
    
    // const test = () => { let form_data = {activity_point : 2, meta_time: 3};  axiosData.post(`/api/_web3/user/set-game-statistics`, form_data).then((res) => { console.log('res', res) }) }

    // register
    const registerForm = () => {

        // test (); return false;

        if (Error) {
            toast.error('Please fix errors');
            return false;

        }

        let form_data = new FormData(); 

        let keys = [];

        if (Object.keys(UserData).length > 0) {
            for (let x in UserData) {
                if (UserData[x] != '') {
                    form_data.append(x, UserData[x]);
                    keys.push(x);
                }
            }
        }

        if (keys.length !== 4) {
            toast.error('Please fill all fields');
            return;
        }
        
        // console.log('send UserData', UserData, referrer)
        setLoadingBtn(true);

        // console.log('put register' , form_data)
        axiosData
         .post(`/api/_web3/register/`, form_data)
         .then((res) => {
            console.log('response', res);

            if (res.data.success && res.data.success === true) {
                toast.success("Created Successfully!")
                
                setTimeout(()=>{
                    redirectTo('/login')
                }, 3000)
            } else {
                toast.error(res.data.error);
            }
            setLoadingBtn(false);

         })
        .catch((error) => {
            
            // console.log('put error: ', error);
            // setErrors(error.response.data.errors);
            toast.error(error.response.data.message);
        })
        .finally(() => setLoadingBtn(false));
    };






    useEffect(() => {  
        
        const referrer = getCookie('referrer')

        if (typeof referrer == 'string'  && /^([0-9a-zA-Z]{4,30})$/.test(referrer)) {
            setReferrer(referrer); 
            setFormData(referrer, 'referrer')
        }
        
    }, [])


    return (
        <div className="min-h-calc-head h-full flex items-center justify-center pb-8" style={{paddingTop: "92px", background: `url(${PATH + 'bg-auth.png'}) center center / cover`}}>
            <div className="container mx-auto">
                <Layout className="bg-transparent h-full">
                    <Content className="pt-4 pb-4 pl-14 pr-14 xs-p-2">
                        <div className="flex flex-col items-center gap-y-5">
                            <div className="login-note">
                                Please make sure you are visiting
                                <div>
                                    <i className="icon-lock-closed text-green-400 mr-1"></i>
                                    <span className="text-green-400"> https://</span>app.metafluence.com
                                </div>
                            </div>
                            <ToastContainer />
                            <div className="flex justify-center">
                                <div className="register-form form-box">
                                    <h1 className="text-center text-white font-normal text-xl mb-2">New Account</h1>
                                    <Row gutter={74} className="register-form-row">
                                        <Col xs={24} sm={24} md={12} lg={12} className="mt-2 mb-2 register-form-left">
                                            <div>
                                                <label htmlFor="acc_username" className="text-white text-base mb-2 block">Username <span className="text-red">*</span></label>
                                                <div className="flex items-center gap-x-6 mb-4">
                                                    <input
                                                        onChange={(e) => {setFormUsername(e.target.value)}}
                                                        className={`bg-indigo-700 border-0 login-input w-100 rounded-md text-white ${Error?'input-error' : ''}` }
                                                        type="text"
                                                        defaultValue=""
                                                        name="username"
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="acc_email" className="text-white text-base mb-2 block">E-mail <span className="text-red">*</span></label>
                                                <div className="flex items-center gap-x-6 mb-4">
                                                    <input
                                                        onChange={(e) => setFormData(e.target.value, 'email')}
                                                        className="bg-indigo-700 border-0 login-input w-100 rounded-md text-white"
                                                        type="text"
                                                        defaultValue=""
                                                        name="email"
                                                        required={true}
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="acc_desc" className="text-white text-base mb-2 block">Password <span className="text-red">*</span></label>
                                                <input
                                                    onChange={(e) => setFormData(e.target.value, 'password')}
                                                    className="bg-indigo-700 border-0 login-input w-100 rounded-md text-white xs-w-100"
                                                    type="password"
                                                    defaultValue=""
                                                    name="name"
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} className="mt-2 register-form-right">
                                            <div>
                                                <label htmlFor="acc_username" className="text-white text-base mb-2 block">Referral Code <span className="text-red">*</span></label>
                                                <div className="flex items-center gap-x-6 mb-4">
                                                    <input
                                                        // onChange={(e) => setFormData(e.target.value, 'referer')}
                                                        className="bg-indigo-700 border-0 login-input w-100 rounded-md text-white"
                                                        type="text"
                                                        defaultValue={Referrer != '' ? Referrer : UserData.referrer}
                                                        name="referer"
                                                        required={true}
                                                        disabled={Referrer!=''?true:false}
                                                        onChange={(e) => setFormData(e.target.value, 'referrer')}
                                                    />
                                                </div>
                                            </div>
                                            <p className="text-xs font-light">In order to register, a referral code is mandatory.<br />
                                                However, if you do not possess a referral code,
                                                you can<br /> join our channels and request the community to provide<br /> you with one.
                                            </p>
                                            <a href="https://t.me/metafluence" target="_blank" className="leading-0 mt-5 text-white hover:text-cyan-500 flex items-center gap-x-2">
                                                <i className="icon-telegram text-xl"></i>
                                                <span className="font-light text-sm">Telegram group</span>
                                            </a>
                                            <a href="https://discord.com/invite/metafluence-official" target="_blank" className="leading-0 mt-3 text-white hover:text-cyan-500 flex items-center gap-x-2">
                                                <i className="icon-discord text-xl"></i>
                                                <span className="font-light text-sm">Discord server</span>
                                            </a>
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} className="mt-2">
                                            {/*<Checkbox className="text-white text-sm font-light ml-0 mb-2" onChange={(e) => { ChangeAgrement(e.target.checked)}}  value="second">I hereby confirm that I have read and agree to the <Link to="#" className="text-sm text-cyan-500">Terms & Conditions</Link>, <Link to="#" className="text-sm text-cyan-500">SAFT</Link>, <Link to="#" className="text-sm text-cyan-500">Wallet Terms</Link>,<br /> <Link to="#" className="text-sm text-cyan-500">Earn Terms</Link> and <Link to="#" className="text-sm text-cyan-500">Privacy Policy</Link> of Metafluence</Checkbox>*/}
                                            <Checkbox className="text-white text-sm font-light ml-0 mb-2" onChange={(e) => { ChangeAgrement(e.target.checked)}}  value="second">I hereby confirm that I have read and agree to the <NavLink to={ROUTES_CONFIG.terms.path} className="text-sm text-cyan-400 hover:text-cyan-500">Terms & Conditions</NavLink>, <NavLink to={ROUTES_CONFIG.saft.path} className="text-sm text-cyan-400 hover:text-cyan-500">SAFT</NavLink> and <NavLink to={ROUTES_CONFIG.privacy.path} className="text-sm text-cyan-400 hover:text-cyan-500">Privacy Policy</NavLink> of Metafluence</Checkbox>
                                            <div className="mt-2 flex flex-col gap-y-4 items-center">
                                                <Button type="submit" onClick={registerForm} disabled={Agrement ? '' : 'disable'} className={`border-0 rounded-3xl font-medium text-base login-btn flex items-center justify-center gap-x-3 ${Agrement ? 'bg-cyan-500 text-indigo-900 hover:bg-cyan-400' : 'bg-indigo-600 text-white opacity-50 cursor-not-allowed'}`}>
                                                    {loadingBtn ? <span className="loading-btn"></span> : ""}
                                                    Register
                                                </Button>
                                                <div>
                                                    <span>Already have a Metafluence account? • <Link to="/login" className="text-sm text-cyan-500">Sign In</Link></span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>




                        {/*<div className="flex flex-col items-center w-100 register-form">*/}


                            {/*<div>
                                <label htmlFor="acc_name" className="text-white text-base mb-2 block">Full name</label>
                                <div className="flex items-center gap-x-6 mb-6">
                                    <input
                                        onChange={(e) => setFormData(e.target.value, 'name')}
                                        className="bg-indigo-700 border-0 input rounded-md text-white"
                                        type="text"
                                        defaultValue=""
                                        name="name"
                                    />
                                </div>
                            </div>*/}




                            {/*<div className="w-354">
                                <label htmlFor="acc_desc" className="text-white text-base mb-2 block">Country</label>
                                <Select
                                    className="custom-select country-select mb-6 input"
                                    showSearch
                                    placeholder="Select one"
                                    optionFilterProp="children"
                                    onChange={onChange}
                                    onSearch={onSearch}
                                >
                                    {listCountries}
                                </Select>
                            </div>*/}

                        {/*</div>*/}

                        {/*
                            <div className="flex flex-col gap-y-10">
                                <div className="relative">
                                    {loadingImage ?
                                        <div className="loading-overlay">
                                            <span className="loading-image"></span>
                                        </div> : ""
                                    }
                                    <img src="" width="125" height="125" className="border-indigo-700 rounded-5xl" />
                                </div>
                                <div className="upload-btn-wrapper">
                                    <Button className="bg-cyan-500 border-0 rounded-2xl">Upload Avatar</Button>
                                    <input type="file" />
                                </div>
                            </div>
                        */}

                    </Content>
                </Layout>
            </div>
        </div>
    )
}

export default Register;